export const environment = {
  env: "prod",
  production: true,
  enableSetRCsubaccount: false,
  enableDashboard: false,
  firstIndexPnl: true,
  sURL: "https://prod-api.sadmincontrol.com/v1/api/",
  bURL: "https://prod-api.sadmincontrol.com",
  mURL: "https://prod-market.sadmincontrol.com",
  riskCalculatorURL: "https://prod-feed-rust.sadmincontrol.com/risk_calculator",
  betTickerURL: "https://betticker",
  betTickerV1URL: "https://betticker-v1",
  pspAdminURL: "https://psp-admin.freedemokit.com",
  kjsport9URL: "https://kjs-back.pkrsrv.com/webadmin-VDX0Xj",
  casinoApiBaseUrl: "https://prod-casino.sadmincontrol.com",
  shivajiexchangeAdminURL: "https://admin.shivajiexchange.com",
  FARO_URL: "https://prod-faro.sadmincontrol.com/collect",
  OTEL_ENABLED: false,
  tracePropagationTargets: [/^https:\/\/prod-api\.sadmincontrol\.com\//],
};
